import React from "react";
import Header from "../components/Header";
import Content from "../components/Content";
import AutoScaler from "../components/AutoScaler";

const Layout = ({ children }) => {
  return (
    <AutoScaler>
      <div className="Layout">
        <Header />
        <Content>{children}</Content>
      </div>
    </AutoScaler>
  );
};
export default Layout;